import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import { makeStyles, createMuiTheme, withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import firebase from "firebase";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ReactCodeInput from 'react-verification-code-input';
// import Copyright from './Copyright';
import grey from '@material-ui/core/colors/grey';
import { connect } from 'react-redux'
// import Loader from 'react-loader-spinner';
import { signIn, forgotPass, loginAs } from '../../store/actions/authActions'
import { Redirect } from 'react-router-dom';

const theme = createMuiTheme({
    palette: {
        primary: {
        main: grey[800],
        },
        secondary: {
        main: grey[300],
        },
    },
});  

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: "85vh"
    },
    phone: {
      margin: theme.spacing(5,0),
    },
    form: {
      width: '80%', // Fix IE 11 issue.
    },
    submit: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalPaper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      textCenter: "center",
    },
  }));
  
const CssTextField = withStyles({
    root: {
      "& label.Mui-focused": {
        color: "black"
      },
      "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
          borderColor: "black"
        }
      }
    }
  })(TextField);
  
function Login(props) {
    const classes = useStyles(theme);
    const [ verifier,    setVerify ]    = useState(false);
    const [ phoneInput,  setPhone  ]    = useState("");
    const [ codeInput,   setCode   ]    = useState(0);
    useEffect(() => {
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('loginBtn', {
        'size': 'invisible',
        'callback': function(response) {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // onSignInSubmit();
          // console.log(phoneInput);
          // props.signIn(phoneInput);
          setVerify(true);
        }
      });
      // async function getUser() {
      //   let user = await firebase.auth().currentUser;
      //   console.log("user?", user);
      // }
      // getUser();
      
    });

    const submitCredentials = phone => {
      if ( phone.length === 10 ) {
        setVerify(false);
        props.signIn(phone);
      } else {
        alert("Phone Number must be at least 10 digits.")
      }
    }
  
    const verifyCode = code => {
      window.confirmationResult.confirm(code).then(function (result) {
        props.loginAs(result.user);
        window.location.reload();
      }).catch(function (error) {
        alert("Incorrect Verification Code")
      });
    }

  return !props.auth.uid ?
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img src="/logo.png" alt="Max Control Logo" height="80" />
        <form className={classes.form} noValidate onSubmit={(e) => {e.preventDefault(); submitCredentials(phoneInput);}}>
          <CssTextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="phone"
            onChange={(e) => setPhone(e.target.value)}
            label="Phone Number"
            name="number"
            autoComplete="phone"
            autoFocus
            className={classes.phone}
          />
          <Button
            type="button"
            fullWidth
            variant="contained"
            id="loginBtn"
            onClick={() => submitCredentials(phoneInput)}
            className={classes.submit}
          >
            Login
          </Button>
        </form>
      </div>
      {/* <Box mt={8}>
        <Copyright />
      </Box> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={(props.openVerify != null ? true : false) || verifier}
        onClose={() => setVerify(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={(props.openVerify != null ? true : false) || verifier}>
          <div className={classes.modalPaper}>
            <h2 style={{textAlign: "center"}} id="transition-modal-title">Verify</h2>
            <ReactCodeInput onChange={code => setCode(code)} type="number" inputStyle={{":focus": "1px solid black"}}/>
            <Button
              type="button"
              fullWidth
              variant="contained"
              id="verifyBtn"
              onClick={() => { verifyCode(codeInput); }}
              className={classes.submit}
            >
              Submit
            </Button>
          </div>
        </Fade>
      </Modal>
    </Container>
  : <Redirect push to={`/admin/`} />;

}
  
const mapStateToProps = (state) => {
  return{
    openVerify: state.auth.openVerify,
    auth: state.firebase.auth,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signIn:     (creds) => dispatch(signIn(creds)),
    loginAs:     (user) => dispatch(loginAs(user)),
    // forgotPass: (email) => dispatch(forgotPass(email)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)